import {TEmailIconProps} from "@/app/[locale]/common/assets/EmailIcon/types";

export const EmailIcon = ({ color }: TEmailIconProps) => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            {
                color === 'white' &&
                <>
                    <g clipPath="url(#clip0_422_473)">
                        <path
                            d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
                            fill="white"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_422_473">
                            <rect width="24" height="24" fill="white"/>
                        </clipPath>
                    </defs>
                </>
            }
            {
                color === 'black' &&
                <>
                    <g clipPath="url(#clip0_239_986)">
                        <path
                            d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
                            fill="#1F1F1F"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_239_986">
                            <rect width="24" height="24" fill="white"/>
                        </clipPath>
                    </defs>
                </>
            }
        </svg>
    );
};